module.exports = __webpack_public_path__ + "img/arrow_right_red.98e7a047.svg";